module.exports = __webpack_public_path__ + "static/media/card_back.60bbd3ab.png";